import React from 'react';
import styled, { css } from 'styled-components';
import { useObserver } from 'mobx-react-lite';
import { GqlCollectionCardBadge } from 'types/graphql';
import { LockIconSimpleSmall } from 'src/assets/lock-icon-simple-small';
import useUser from 'src/hooks/use-user';

type CollectionBadgeProps = {
  collectionCardBadge: GqlCollectionCardBadge;
};

export const CollectionBadge = ({ collectionCardBadge }: CollectionBadgeProps): JSX.Element | null => {
  const { color, isAccessibleToCurrentUser, isExclusive, title } = collectionCardBadge;

  const User = useUser();
  const isLoggedIn = useObserver(() => User.isLoggedIn);

  // Hide badge for exclusive collections when user lacks access (matches carousel logic in use-collections.ts)
  if (isExclusive) {
    if (!isLoggedIn || !isAccessibleToCurrentUser) {
      return null;
    }
  }

  return (
    <Badge $color={color} $isExclusive={isExclusive}>
      {isExclusive && <LockIconSimpleSmall color='currentColor' />}
      {title}
    </Badge>
  );
};

const Badge = styled.div<{
  $color: GqlCollectionCardBadge['color'];
  $isExclusive: GqlCollectionCardBadge['isExclusive'];
}>`
  align-items: center;
  color: ${({ $color }) => $color ?? 'currentColor'};
  display: flex;
  gap: 4px;
  justify-content: var(--justify-content, flex-start);
  width: 100%;

  ${({ $isExclusive }) =>
    !$isExclusive &&
    css`
      &::before {
        background: currentColor;
        content: '';
        height: 6px;
        margin: 0 3px;
        transform: rotate(45deg);
        width: 6px;
      }
    `}

  svg {
    width: 12px;
    height: 12px;
  }
`;
